<template>
  <div class="event-item">
    <div class="event-icon left-side" :class="eventInfo.class">
      <img v-if="eventInfo.imgSrc" :src="eventInfo.imgSrc" />
    </div>
    <div class="inline-block">
      <div class="status-text secondary-font">
        {{ eventInfo.text | firstLetterCapitalize }}
      </div>
      <!-- if assessment event, then show answer and time -->
      <div v-if="eventInfo.answer">
        <span>{{ eventInfo.answer | firstLetterCapitalize }}</span>
        <span class="secondary-font small-font ml-2">
          ({{ moment(item.TimeStamp).format('h:mm A') }})
        </span>
      </div>
      <!-- if void event, then only show time -->
      <div v-else>
        {{ moment(item.TimeStamp).format('h:mm A') }}
      </div>
      <div v-if="item.Duration">
        <div class="status-text mt-5 secondary-font">
          {{ $t('text.duration') }}
        </div>
        <div>{{ item.Duration | secondFormat }}</div>
      </div>

      <!-- if pad end, should show some summary info -->
      <div v-if="shouldShowPadInfoEventTypes.includes(item.Status)">
        <div class="status-text secondary-font mt-5">
          {{ $t('text.product_name') }}
        </div>
        <div>{{ dayItem.ProductName || '--' }}</div>
        <div class="status-text secondary-font mt-5">
          {{ $t('text.total_void') }}
        </div>
        <div>
          {{ dayItem.TotalVoid !== '' ? dayItem.TotalVoid + 'ml' : '--' }}
        </div>
        <div class="status-text secondary-font mt-5">
          {{ $t('text.utilisation') }}
        </div>
        <div>
          {{ dayItem.PadStatus !== '' ? dayItem.PadStatus + '%' : '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/main.js'
import moment from 'moment'
import { voidConst } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
export default {
  data() {
    return {
      app,
      moment,
      shouldShowPadInfoEventTypes: [
        voidConst.padEndLevel1,
        voidConst.padEndLevel2,
        voidConst.padEndLevel3,
        voidConst.padEndLevel4,
        voidConst.padEndLevel5
      ]
    }
  },
  props: {
    eventInfo: {
      type: Object,
      require: false,
      default: function() {
        return {
          text: '',
          imgSrc: '',
          class: '',
          answer: ''
        }
      }
    },
    item: {
      type: Object,
      require: true
    },
    dayItem: {
      type: Object,
      require: true
    }
  }
}
</script>
